import Link from 'next/link';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import Image from 'next/image';

type VariantButtonProps = {
  current?: boolean;
  value: string;
  type: 'text' | 'image';
  href: string;
  image?: string;
  onHover?: () => void;
  onLeave?: () => void;
};

export default function VariantButton({
  current = false,
  value,
  type,
  href,
  image,
  onHover = () => {},
  onLeave = () => {},
}: VariantButtonProps) {
  const isDisabled = href === '';
  const Element = current || isDisabled ? 'span' : Link;

  return (
    <Element
      scroll={false}
      href={href}
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
      className={twMerge(
        clsx(
          'p-2 border border-neutral-40 rounded min-w-16 flex justify-center',
          {
            'bg-secondary-30 border-secondary-60': current,
            'p-4': type === 'image',
            'opacity-40 cursor-default': isDisabled,
            'hover:border-secondary-60 hover:bg-secondary-30':
              !current && !isDisabled,
          }
        )
      )}
    >
      {type === 'image' && image ? (
        <div className="relative w-14 h-14 object-contain-child-img">
          <Image src={image} alt={value} fill />
        </div>
      ) : (
        <span className="body-sm flex items-center">{value}</span>
      )}
    </Element>
  );
}
